import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import LabelAndSelectChange from '../form/labelAndSelectChange';

import { getControladorList } from './selectdbAtions';

class SelectAllControladorNumero extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value
        }
    }

    componentWillMount() {
        this.props.getControladorList();
    }

    renderOptions() {
        const list = this.props.list || [];
        var listCont = [];

        list.forEach(cont => {
            if (this.props['data-grupofisico-id'] == cont.grupo_fisico_id) {
                if (!listCont.find(item => item.numero_controlador === cont.numero_controlador)) {
                    listCont.push(cont);
                }
            }
        });

        return listCont.map(contro => (
            <option key={contro.numero_controlador} value={contro.numero_controlador}>
                Controlador {contro.numero_controlador.toString().padStart(2, '0')}
            </option>
        ))
    }

    render() {

        return (

            <LabelAndSelectChange
                id={this.props.id}
                name={this.props.name}
                label={this.props.label}
                cols={this.props.cols}
                onChange={(event) => {
                    this.setState({ value: event.target.value });
                    this.props.onChange(event);
                }}
                value={this.state.value}
            >
                <option>Todos do Grupo Físico</option>
                {this.renderOptions()}
            </LabelAndSelectChange>

        )
    }
}

const mapStateToProps = state => ({ list: state.controladorCad.listHeader })
const mapDispatchToProps = dispatch => bindActionCreators({ getControladorList }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(SelectAllControladorNumero)